module.exports = __webpack_public_path__ + "static/media/No_Projects_Assigned.a48566af.svg";